import React from "react";
import { lazy } from "react";
import { GamesSearchByFilters } from "components/games/GamesSearch/GamesSearchByFilters";
import { useAuth } from "provider/AuthContext";
import { Navigate } from "react-router-dom";

const AppLayout = lazy(() => import("components/shared/Layouts/AppLayout"));
const HomePage = lazy(() => import("pages/home/HomePage"));
const CasinoPage = lazy(() => import("pages/casino/CasinoPage"));
const LiveCasinoPage = lazy(() => import("pages/live-casino/LiveCasinoPage"));
const MiniGamesPage = lazy(() => import("pages/mini-games/MiniGamesPage"));
const SportsbookPage = lazy(() => import("pages/sportsbook"));
const PromotionsPage = lazy(() => import("pages/promotions/PromotionsPage"));
const GamePlay = lazy(() => import("components/games/GamePlay"));

export default function PublicRoutes() {
  const { user } = useAuth();
  const isUserRole = user?.role === "User";
  return [
    {
      path: "/",
      element: <AppLayout />,
      children: [
        { index: true, element: <HomePage /> },
        ...((user && isUserRole) || !user
          ? [
              { path: "/sportsbook/live", element: <SportsbookPage /> },
              { path: "/sportsbook/sports", element: <SportsbookPage /> },
              {
                path: "/casino/:category/:sortOrder",
                element: <CasinoPage />,
                children: [{ path: "*", element: <GamesSearchByFilters /> }],
              },
              {
                path: "/live-casino/:category/:sortOrder",
                element: <LiveCasinoPage />,
                children: [{ path: "*", element: <GamesSearchByFilters /> }],
              },
              {
                path: "/mini-games/:category/:sortOrder",
                element: <MiniGamesPage />,
              },

              { path: "/promotions", element: <PromotionsPage /> },
            ]
          : []),
        { path: "/game-play/:id", element: <GamePlay /> },

        // Redirect unknown routes to the home page
        { path: "*", element: <Navigate to="/" /> },
      ],
    },
  ];
}
